import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Store } from '@ngrx/store';
import { AppStateInterface } from '../../store/state/app.state';
import { uuidSelector } from '../../store/selectors/profile.selectors';

@Injectable({
  providedIn: 'any',
})
export class RateService {
  private uuid: string = '';

  constructor(private api: ApiService, private store: Store<AppStateInterface>) {
    this.store.select(uuidSelector).subscribe((uuid) => {
      this.uuid = uuid;
    });
  }

  setRate(rate: number, expert_id: number, ticket_id: number) {
    return this.api.post(
      '/api/user/store/rate/web',
      {
        rate,
        expert_id,
        ticket_id,
      },
      {
        Authorization: this.uuid,
      },
    );
  }
}
